import { Component, Input } from '@angular/core';

@Component({
  selector: 'vfs-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss']
})
export class EmptyStateComponent {
  @Input() noResults: boolean = false; //show & hide component
  @Input() text: string; // text under the image and hint, text-base color
  @Input() hint: string; // text under the image with the same color
  @Input() opaque = false;
}
